import { Logo } from "./Logo";
import { WhatsGlyph } from "./WhatsGlyph";
import { AnnouncementBar } from "./AnnouncementBar";
import { scrollToId, waLink, DEFAULT_MSG } from "@/data/site";

const links = [
  { label: "Início", href: "#inicio" },
  { label: "Benefícios", href: "#beneficios" },
  { label: "Planos", href: "#planos" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => (
  <header
    className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-ink/70 backdrop-blur-xl"
    data-testid="navbar"
  >
    <AnnouncementBar />
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
      <Logo onClick={() => scrollToId("#inicio")} />
      <nav className="hidden items-center gap-8 md:flex">
        {links.map((l) => (
          <button
            key={l.href}
            onClick={() => scrollToId(l.href)}
            data-testid={`nav-link-${l.href.slice(1)}`}
            className="font-mono text-[11px] uppercase tracking-[0.2em] text-mist transition-colors hover:text-neon"
          >
            {l.label}
          </button>
        ))}
      </nav>
      <a
        href={waLink(DEFAULT_MSG)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="header-whatsapp-cta"
        className="inline-flex items-center gap-2 rounded-full bg-wa px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-[#052e16] transition-colors hover:bg-wa-hover"
      >
        <WhatsGlyph className="h-4 w-4" />
        Assinar
      </a>
    </div>
  </header>
);
